import { useIsAuthenticated, useMsal } from '@azure/msal-react'
import { useCallback, useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { LocationWithState } from 'types/location'

import { api } from '../../../api'
import { PATH } from '../../../const'

const runtimeConfig = window && (window as any).authConfig

export const useAADLogin = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const [aadError, setAADError] = useState<string | null>(null)
  const clientId = (runtimeConfig?.clientId ?? import.meta.env.VITE_AAD_CLIENT_ID) as string
  const aadButtonText =
    runtimeConfig?.buttonText ??
    import.meta.env.VITE_AAD_BUTTON_TEXT ??
    (clientId?.length && clientId !== '<client-id>' ? 'Single Sign-On' : null)

  const isAuthenticated = useIsAuthenticated()

  const { instance } = useMsal()

  const [triggerGetUser, { data: user }] = api.useLazyGetUsermanagerCurrentQuery()

  const aadLoggedIn = useCallback(
    (/* loginResponse */) => {
      triggerGetUser()
    },
    [triggerGetUser]
  )
  useEffect(() => {
    // When we have the user data, redirect the user
    if (user) {
      const redirectPath = (location.state as any)?.from
        ? (location as LocationWithState).state.from.pathname
        : PATH.home

      navigate(redirectPath)
    }
  }, [location, navigate, user])

  const aadLogin = useCallback(() => {
    setAADError(null)
    instance
      .loginPopup() // NB: Could use loginRedirect instead
      .catch(err => setAADError(err))
      .then(aadLoggedIn)
  }, [instance, setAADError, aadLoggedIn])
  const aadLogout = useCallback(() => {
    setAADError(null)
    instance
      .logoutPopup() // NB: Could use logoutRedirect instead
      .catch(err => setAADError(err))
  }, [instance, setAADError])
  return {
    aadButtonText,
    aadLogin,
    aadLogout,
    isAuthenticated,
    aadError
  }
}
